import { render, staticRenderFns } from "./AllegatiLista.vue?vue&type=template&id=5b0c8e04&scoped=true&"
import script from "./AllegatiLista.vue?vue&type=script&lang=js&"
export * from "./AllegatiLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0c8e04",
  null
  
)

export default component.exports